<template>
  <div
    class="moow-master-container play-background"  
  >
    <nav-basic :progress="100" title="" :btn="false"></nav-basic>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
      </div>
    </div>

    <div class="container">
      <!-- <b-row class="step-header">
        <p v-if="disableNext" class="moow-header">Getting Ready...</p>
        <p v-else class="moow-header">All Set</p>
      </b-row> -->

      <b-row>
        <b-col md="6" class="form-container amenities-form">
          <md-card class="island-card pr-3">
            <md-card-header>
        <p v-if="disableNext" class="moow-header">Getting Ready...</p>

        <div v-else class="md-title">All Set</div>
      </md-card-header>
            <md-card-content>
              <p class="moow-info-txt">Publish Your listing on Moowle and our partner real-estate portals now or save as draft to publish later.</p>
              <md-checkbox v-model="agreed" class="md-primary"><a @click="showTerms=true">I agree with terms and condition</a></md-checkbox>
            </md-card-content>
            <md-card-actions>
              <div v-if="disableNext">
                <div class="loader-rolling-local_blue"></div>
              </div>
              <div v-else>
                                  <moow-button
                    :type="['dark', 'outlined', 'flat']"
                    btnText="Save as draft"
                    @mClick="saveAndExit"
                  />
                  <moow-button
                    :type="['light']"
                    btnText="Publish"
                    @mClick="publish"
                  />
                  
              </div>
            </md-card-actions>
          </md-card>
          <!-- <b-row class="mt-5" v-if="disableNext">
            <b-col style="text-align:left;padding:0">
              <div class="loader-rolling-local_blue"></div>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <div class="loader-rolling-local_blue"></div>
            </b-col>
          </b-row> -->


          <!-- <b-row class="step-navigator-buttons" v-else>
            <b-col style="text-align:left;padding:0">
                     <md-button @click="saveAndExit" class="md-primary play-cta-button-flat grey">Save As Draft</md-button>

            </b-col>
            <b-col style="text-align:right;padding:0">
              <md-button @click="publish" class="md-primary play-cta-button makeup">Publish</md-button>
            </b-col>
          </b-row> -->


          <!-- <b-row class="mt-5" v-else>
            <b-col style="text-align:left;padding:0">
              <md-button  @click="saveAndExit" class="md-primary play-cta-button-flat navy">Save as Draft</md-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <md-button  @click="publish" class="md-primary play-cta-button navy">Publish</md-button>
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>


      <md-dialog :md-active.sync="showCannotPublishDialog">
        <md-dialog-title>Missing information</md-dialog-title>
        <md-content class="pl-4">
          <p>{{cannotPublishMessage}}</p>
        </md-content>
        <md-dialog-actions>
          <!-- <md-button class="md-primary" @click="saveAsDraftFromDialog" :disable="disableNext">Save as Draft</md-button> -->
          <md-button class="md-primary" v-if="missingPricing" @click="changePricingFromDialog">Edit pricing</md-button>
          <md-button class="md-primary" v-else-if="missingTitle" @click="changeTitleFromDialog">Edit title</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
    
    <md-dialog :md-active.sync="showTerms">
      <terms-conditions
        @makeDecision="closeTermsDialog"></terms-conditions>
    </md-dialog>
  </div>
</template>

<script>
  import {
    updateListingParts
  } from '../listingFunctions.js'
  import {
    addListing,
    getUserUid,
    onBeforeAddListingSaveAndExit
  } from '../functions.js'
  import TermsAndConditions from '../components/dialogs/TermsAndConditions'

  export default {
    name: 'price4',
    components: {
      'terms-conditions': TermsAndConditions
    },
    data() {
      return {
        loading: false,
        showCannotPublishDialog:false,
        cannotPublishMessage: "",
        missingPricing:false,
        missingTitle:false,
        showTerms: false,
        agreed:false
      }
    },
    computed: {
      availDet() {
        return this.$store.getters.availDet
      },
      disableNext(){
        return this.$store.getters.listingProgress == 'LISTING_PENDING'
      },
      currentAccountPrivPerson() {
        var p = this.$store.getters.privatePerson;
        if (!p || Object.keys(p).length == 0) return false;
        else if (p && p.state == "loading") return "loading";
        else return p;
      }
    },
    methods: {
      closeTermsDialog(decision){
        if(decision) this.agreed=true
        this.showTerms=false
      },
      saveAsDraftFromDialog(){
        this.showCannotPublishDialog = false
        this.saveAndExit()
      },
      changePricingFromDialog(){
        this.showCannotPublishDialog = false
        this.leavePage('PRICE4', 'price1')
      },
      changeTitleFromDialog(){
        this.showCannotPublishDialog = false
        this.leavePage('PRICE4', 'scene2')
      },
      publish(){
        if(!this.currentAccountPrivPerson){
          this.notifyUser("Specify Identity", "To make sure tenants can directly book the place, specify your identity.")
          this.navigateToAccount()
        } 
        else if(!this.agreed) this.notifyUser("Missing information", "Agree to terms and conditions")
        else if(!this.$store.getters.marketingDet.shortDesc){
          this.cannotPublishMessage="Specify title for this listing"
          this.missingTitle=true
          this.missingPricing = false
          this.showCannotPublishDialog = true
        }else if(!this.$store.getters.txnDet.priceMonthly && !this.$store.getters.txnDet.priceDaily){
          this.cannotPublishMessage="Specify pricing for this listing"
          this.missingPricing = true
          this.missingTitle=false
          this.showCannotPublishDialog = true
        }else{
          this.availDet.status = 'active'
          this.saveAndExit()
        }
      },
      navigateToAccount(){
        this.navigateTo( 'account', { postSaveRedirect: 'dashboard', openWithTab: 'tab-identity' });
      },
      navigateTo(where, params) {
        this.$router.push({
          name: where,
          params: params,
        });
      },
      saveAndExit() {
        this.loading = true
        onBeforeAddListingSaveAndExit()
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.commit('UPDATE_AVAILDET', this.availDet)
            updateListingParts(this.createUpdateParts())
              .then(result => {
                this.loading = false
                if(result) this.leavePage('PRICE4', 'dashboard')
                else this.notifyUser('Something is wrong', 'Try again or reload page')
              })
              .catch(err => {
                this.loading = false
                this.notifyUser('Notification', err)
              })
          } else {
            this.loading = false
            this.notifyUser('Notification', 'Some fields are missing')
          }
        })
      },
      createUpdateParts(){
        return{
          'availDet': this.availDet
        }
      },
      notifyUser(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
    },
    props: {
      data: {
        type: Object,
        required: false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/styles/global.css';
  @import '../assets/styles/add-steps.css';


  img {
    margin: 0 10px 0 10px;
  }

  #desc {
    background-color: #fafafa;
  }

  .checkBtn {
    opacity: 0;
    outline: none;
    position: absolute;
    margin: 0;
    left: -999px;
  }

  p {

    text-align: left;
    font-size: 14px;
  }

  .row {
    margin-bottom: 20px;
  }

  .socialBtn {
    margin-top: 10px;
    background-color: #fafafa;
    width: 492px;
    height: 78px;
    border-radius: 8px;
    border: solid 1px #d8d8d8;
    text-align: center;
    padding-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/price4.vue